import React, { useState } from 'react';
import { useI18n } from '../contexts/I18nContext';

const HelpPanel: React.FC = () => {
  const { t } = useI18n();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* ? 버튼 — 미니맵(top:10, right:10, 200px wide) 바로 아래 */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: 'fixed',
          top: 240,
          right: 10,
          width: 200,
          height: 30,
          borderRadius: '0 0 8px 8px',
          border: '1px solid #e2e8f0',
          borderTop: 'none',
          backgroundColor: isOpen ? '#3b82f6' : 'rgba(255,255,255,0.95)',
          color: isOpen ? '#fff' : '#64748b',
          fontSize: '12px',
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px',
          zIndex: 100,
          boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
          transition: 'all 0.15s ease',
        }}
        title={t.help.title}
      >
        <span>?</span> {t.help.title}
      </button>

      {/* 패널 — 버튼 아래로 펼침 */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 274,
            right: 10,
            width: 320,
            maxHeight: 'calc(100vh - 300px)',
            overflowY: 'auto',
            backgroundColor: 'rgba(255,255,255,0.97)',
            borderRadius: '12px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
            border: '1px solid #e5e7eb',
            zIndex: 1000,
            padding: '16px',
            fontSize: '13px',
            color: '#374151',
            animation: 'helpIn 0.12s ease-out',
          }}
        >
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px',
          }}>
            <span style={{ fontWeight: 700, fontSize: '15px', color: '#111827' }}>
              {t.help.title}
            </span>
            <button
              onClick={() => setIsOpen(false)}
              style={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                color: '#9ca3af',
                padding: '2px 6px',
              }}
            >
              ✕
            </button>
          </div>

          {t.help.sections.map((section, idx) => (
            <div key={idx} style={{ marginBottom: '14px' }}>
              <div style={{
                fontWeight: 600,
                fontSize: '13px',
                color: '#1f2937',
                marginBottom: '6px',
                paddingBottom: '4px',
                borderBottom: '1px solid #f3f4f6',
              }}>
                {section.title}
              </div>
              <ul style={{
                margin: 0,
                paddingLeft: '18px',
                lineHeight: '1.7',
              }}>
                {section.items.map((item, itemIdx) => (
                  <li key={itemIdx} style={{ color: '#4b5563' }}>{item}</li>
                ))}
              </ul>
            </div>
          ))}

          <style>{`
            @keyframes helpIn {
              from { opacity: 0; transform: translateY(-8px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}</style>
        </div>
      )}
    </>
  );
};

export default HelpPanel;
